import React from 'react';
import { Card, CardContent } from '@components/ui/card';

interface StatCardProps {
    label: string;
    value: React.ReactNode;
    hint?: string;
    trend?: React.ReactNode;
}

export const StatCard = ({ label, value, hint, trend }: StatCardProps) => (
    <Card>
        <CardContent className="flex flex-col gap-2 pt-6">
            <div className="flex items-start justify-between gap-2">
                <span className="text-sm text-muted-foreground">{label}</span>
                {trend}
            </div>
            <span className="text-3xl font-semibold tracking-tight">
                {value}
            </span>
            {hint && (
                <span className="text-sm text-muted-foreground">{hint}</span>
            )}
        </CardContent>
    </Card>
);
